export function stateStorageKey(modelId: number) {
  return `chat_state_model_${modelId}`;
}

export function restoreStateId(args: { modelId: number; isValid: (id: string) => boolean }): string | null {
  try {
    const raw = localStorage.getItem(stateStorageKey(args.modelId));
    const id = raw ? String(raw) : '';
    if (!id) return null;
    return args.isValid(id) ? id : null;
  } catch {
    return null;
  }
}

export function persistStateId(modelId: number, stateId: string) {
  try {
    localStorage.setItem(stateStorageKey(modelId), String(stateId));
  } catch {}
}


